var exports = {
  "kL": "xa9f3555f--74b3a8--container",
  "DD": "xa9f3555f--74b3a8--title",
  "h_": "xa9f3555f--74b3a8--description",
  "rG": "xa9f3555f--74b3a8--security",
};

module.exports = exports;
